import { SELL_YOUR_CAR_PATH } from './wordpress';

export const DEFAULT_LOCATION_PAGES_FOR_LOCAL_BUSINESS_SCHEMA = [
  'birmingham',
  'london',
  'manchester',
] as const;

export const LOCATION_PAGES = [
  ...DEFAULT_LOCATION_PAGES_FOR_LOCAL_BUSINESS_SCHEMA,
  'bradford',
  'brighton',
  'bristol',
  'cardiff',
  'coventry',
  'derby',
  'doncaster',
  'edinburgh',
  'glasgow',
  'leeds',
  'leicester',
  'lincoln',
  'liverpool',
  'newcastle',
  'nottingham',
  'sheffield',
  'southampton',
] as const;

export const SORTED_LOCATION_PAGES = [...LOCATION_PAGES].sort((a, b) => a.localeCompare(b));

export type LocationPage = (typeof LOCATION_PAGES)[number];

type IsLocationPageRouteProps = {
  includeAllLocationPages?: boolean;
  url: string;
};

const locationPageRegexAll = new RegExp(`^(${SELL_YOUR_CAR_PATH})/(${LOCATION_PAGES.join('|')})$`);
const locationPageRegexDefault = new RegExp(`^(${SELL_YOUR_CAR_PATH})/(${DEFAULT_LOCATION_PAGES_FOR_LOCAL_BUSINESS_SCHEMA.join('|')})$`);

export const isLocationPageRoute = (
  { includeAllLocationPages, url }: IsLocationPageRouteProps,
): boolean => (includeAllLocationPages ? locationPageRegexAll : locationPageRegexDefault).test(url);

const sellYourCarRegex = new RegExp(`^${SELL_YOUR_CAR_PATH}/(.+)$`);

export const extractCityFromLocationURL = (url?: string): LocationPage | null => {
  if (!url || typeof url !== 'string') {
    return null;
  }

  const match = sellYourCarRegex.exec(url);
  if (!match?.[1]) {
    return null;
  }

  const city = match[1] as LocationPage;
  return SORTED_LOCATION_PAGES.includes(city) ? city : null;
};
